import type { ReactNode } from "react"

import { Text } from "../Text"
import styles from "./InlineLabel.module.css"

interface Props {
  /**
   * The text value of the label.
   */
  value: string

  /**
   * The form control linked to this label.
   */
  children: ReactNode
}

/**
 * A Label container component for small inline from controls.
 */
export function InlineLabel(props: Props) {
  const { value, children } = props

  return (
    <label className={styles.inlineLabel}>
      {children}
      <Text>{value}</Text>
    </label>
  )
}
